import { useEffect, useState } from "react";
import { Row, Container, Col, Button, Form } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import { useSelector } from "react-redux";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";
import { getFetchParamGenerator, getApiURL } from "../../_services/sat";
import { downloadBlob } from "../../_helpers/excel";


const api = SatAPI();

function Reports() {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [loadingKey, setLoadingKey] = useState(null);
  /*
    const load = async () => {
      try {
        setLoading(true);
        setLoading(false);
      } catch (error) {
        toastService.send({ title: "An error occured", message: error.toString() });
      }
    };
  
    useEffect(() => {
      load();
    }, [snapshot]);
  */
  const generateReport = async (getOpts, filename, key) => {
    setLoadingKey(key);
    try {
      const { fetchParamCreator, fetch } = getFetchParamGenerator();
      const opts = getOpts(fetchParamCreator);
      const resp = await fetch(getApiURL() + opts.url, opts.options);
      // download content as a file in new tab
      const file = await resp.blob();
      downloadBlob(file, filename);
    } catch (resp) {
      console.warn(resp);
    }
    setLoadingKey(null);
  };

  const reportRows = [
    {
      label: "Genereer rapport contacturen docenten per opleiding",
      buttons: [
        { key: "docentenCUExcel", variant: "msexcel", title: "Excel file", icon: "fa-file-excel", getOpts: (c) => c.getDocentenContacturenPerOpleidingReportExcel(snapshot, {}), filename: "DocentenCUPerOpleiding.xlsx" },
        { key: "docentenCUPDF",   variant: "adobepdf", title: "PDF file",  icon: "fa-file-pdf",   getOpts: (c) => c.getDocentenContacturenPerOpleidingReportPDF(snapshot, {}),   filename: "DocentenCUPerOpleiding.pdf" },
      ],
    },
    {
      label: "Genereer rapport met alle toewijzingen",
      buttons: [
        { key: "allAssignments", variant: "msexcel", title: "Excel file", icon: "fa-file-excel", getOpts: (c) => c.getAllAssignmentsExcel(snapshot, {}), filename: "assignments.xlsx" },
      ],
    },
    {
      label: "Genereer rapport met alle docenten",
      buttons: [
        { key: "docenten", variant: "msexcel", title: "Excel file", icon: "fa-file-excel", getOpts: (c) => c.getCollegasExport(snapshot, {}), filename: "collegas.xlsx" },
      ],
    },
    {
      label: "Genereer rapport met alle OPO's",
      buttons: [
        { key: "opos", variant: "msexcel", title: "Excel file", icon: "fa-file-excel", getOpts: (c) => c.getAssignmentsExport(snapshot, {}), filename: "opos.xlsx" },
      ],
    },
    {
      label: "Genereer rapport met alle taak-toewijzingen",
      buttons: [
        { key: "taskAssignments", variant: "msexcel", title: "Excel file", icon: "fa-file-excel", getOpts: (c) => c.getTaskAssignmentsExcel(snapshot, {}), filename: "taaktoewijzingen.xlsx" },
      ],
    },
  ];

  /*
    if (false) {
      return (
        <div className="text-center">
          <i className="fad fa-spinner-third fa-spin fa-5x" />
        </div>
      );
    }
      */
  return (
    <Container>
      <Row>
        <Col>
          <h1>Rapportage</h1>
        </Col>
      </Row>
      <hr />
      {reportRows.map(({ label, buttons }) => (
        <div key={label}>
          <Row>
            <Col className="mt-3 col-5">
              {label} &nbsp;&nbsp;
            </Col>
            <Col className="mt-3 col-7">
              {buttons.map(({ key, variant, title, icon, getOpts, filename }, i) => (
                <span key={key}>
                  {i > 0 && <>&nbsp;</>}
                  <Button title={title} variant={variant} onClick={() => generateReport(getOpts, filename, key)} disabled={loadingKey === key || snapshot}>
                    {loadingKey === key
                      ? <i className="far fa-spinner fa-pulse" />
                      : <i className={`far ${icon}`} />
                    }
                  </Button>
                </span>
              ))}
            </Col>
          </Row>
          <hr />
        </div>
      ))}
      {/*
      <Row>
        <Col className="mt-3 col-5">
        Testing WIP: geneneer prestatieregeling Jitse &nbsp;&nbsp;
        </Col>
          <Col className="mt-3 col-7">
          <Button title="PDF file" variant="danger" onClick={() => generateStaffAssignments()} disabled={loading2 || snapshot}>
            
            {loading2 && 
              <i className="far fa-spinner fa-pulse" />
            }
            {!loading2 && 
              <i className="far fa-file-pdf" />
            }
          </Button>
        </Col>
      </Row>
      <hr />
      */}
    </Container>
  );
}

export default Reports;
